import { lazyWithPreload } from '../../navigation';

export const StyleguideNewScreen = lazyWithPreload(() => import('./StyleguideNewScreen.lazy'));

export type { StyleguideNewScreenProps } from './StyleguideNewScreen.lazy';
